// ============================================================
// หน้า ImportBillUnitUsed — นำเข้าการแจ้งหนี้และจัดเก็บค่าน้ำ (แบบไม่มีเลขมาตรเริ่มต้น-สิ้นสุด)
// ------------------------------------------------------------
// ใช้กับโครงการที่ไฟล์บิลมีแค่ "หน่วยที่ใช้" ไม่มีเลขมาตร ระบบจึงต้องย้อนคำนวณเลขมาตรให้เอง
//
// ขั้นตอนการใช้งาน (ต้องทำตามลำดับ)
//   1. อัปโหลดไฟล์ "เลขมาตรปัจจุบัน" ก่อน — เอาเลขมาตรล่าสุดของแต่ละบ้านมาเป็นจุดตั้งต้น
//   2. อัปโหลดไฟล์ "ข้อมูลน้ำ" — บิลย้อนหลังของแต่ละบ้าน
//   3. ระบบเรียงบิลตามบ้านเลขที่ + วันที่ แล้วไล่ย้อนจากบิลใบล่าสุดขึ้นไป
//        บิลใบล่าสุด : เลขมาตรเดือนนี้ = เลขมาตรปัจจุบัน, เลขมาตรเดือนก่อน = เลขมาตรปัจจุบัน - หน่วยที่ใช้
//        บิลใบก่อน  : เลขมาตรเดือนนี้ = เลขมาตรเดือนก่อนของใบถัดไป แล้วลบหน่วยที่ใช้ไปเรื่อย ๆ
//   4. ตรวจข้อมูลในตาราง แล้วกด "นำเข้า"
//
// หลังนำเข้าสำเร็จจะสั่งคำนวณยอดค้าง/เบี้ยปรับใหม่ทั้งโครงการ (calculate_water)
// ============================================================

import React, { Component } from "react";
import { ReactExcel, readFile, generateObjects } from "@ramonak/react-excel";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar.js";
import excel_file2 from "../../assets/files/import_bill_water.xlsx";
import {
  tokens,
  success,
  alert,
  toFixed,
  GET,
  POST,
  format_date,
  getStorage,
  fieldSorter,
  calculate_water,
  cal_water_bill,
  getWaterSetting,
  calcFireCost,
  loading,
  ExcelDropZone,
  ScrollTopButton,
  ActionIcon,
  ICON,
} from "../../shared/index.js";
import { WATER_BILL_SHEET_NAME, WATER_BILL_COLUMNS, buildBillRow, dropSampleRow } from "../../shared/domain/bill-import.js";
import { findInvalidColumn } from "../../shared/domain/customer-excel.js";

export default class Import extends Component {
  state = {
    // ไฟล์ "ข้อมูลน้ำ"
    import: null,
    currentSheet: null,
    data_import: null,
    // ไฟล์ "เลขมาตรปัจจุบัน"
    import_current: null,
    currentSheet_current: null,
    data_import_current: null,
    // รายชื่อลูกค้า (ใช้ room_size ตอนคิดค่าส่วนกลางตามขนาดห้อง)
    data_customer: [],

    // ค่าจากตั้งค่าโครงการ
    common_expenses_type: 0,
    common_expenses: 0,
    equipment_maintenance_fee: 0,
    waste_cost: 0,
    cable_cost: 0,
    fire_cost: 0,
    add_debt: 0,
    reduce_debt: 0,
    // ตั้งค่าอัตราค่าน้ำ (ส่งให้ cal_water_bill ใช้)
    water_charge_start: 0,
    water_charge_end: 0,
    water_charge_price: 0,
    water_rate_list: [],
    water_calculate_type: 2,
    // ตั้งค่าการตัดมิเตอร์
    meter_cut_month: "",
    meter_cut_date: "",
  };

  componentDidMount() {
    loading(false);
    this.GetSetting();
  }

  // ---------- ตั้งค่าโครงการ ----------

  GetSetting = async () => {
    loading(true);
    const d = await getWaterSetting(getStorage("water_id"));
    if (d) {
      this.setState(
        {
          water_charge_start: Number(d.water_charge.water_charge_start),
          water_charge_end: Number(d.water_charge.water_charge_end),
          water_charge_price: toFixed(Number(d.water_charge.water_charge_price)),
          water_rate_list: d.water_rate_list,
          water_calculate_type: Number(d.water_calculate_type) || 2,
          cable_cost: d.cable_cost,
          common_expenses_type: d.common_expenses_type,
          common_expenses: d.common_expenses,
          equipment_maintenance_fee: d.equipment_maintenance_fee,
          waste_cost: d.waste_cost,
          add_debt: d.add_debt,
          reduce_debt: d.reduce_debt,
          fire_cost: calcFireCost(d, format_date(new Date(), "m")),
          fire_month: d.fire_month,
          meter_cut_month: d.meter_cut_month,
          meter_cut_date: d.meter_cut_date,
          meter_convergence: d.meter_convergence,
        },
        () => {
          if (d.common_expenses_type) this.GetCustomerAll();
        }
      );
    }
    loading(false);
  };

  GetCustomerAll = async () => {
    const result = await GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${getStorage("project_id")}`, { data_search: "", transfer_date: "", status_transfer: "" });
    if (result?.status) this.setState({ data_customer: result.data.data });
  };

  // ---------- อ่านไฟล์ ----------

  // isCurrent = true คือไฟล์ "เลขมาตรปัจจุบัน", false คือไฟล์ "ข้อมูลน้ำ"
  handleFile = (file, isCurrent) => {
    readFile(file)
      .then((readedData) => {
        if (readedData.SheetNames[0] !== WATER_BILL_SHEET_NAME) {
          alert("info", "แจ้งเตือน", "ไฟล์ไม่ถูกต้อง");
          return;
        }
        // รอ 10ms ให้ ReactExcel อัปเดตชีตก่อนอ่านข้อมูล
        this.setState({ [isCurrent ? "import_current" : "import"]: readedData }, () => {
          setTimeout(isCurrent ? this.Import_current : this.Import, 10);
        });
      })
      .catch(console.error);
  };

  // ไฟล์ "เลขมาตรปัจจุบัน" — เอาแค่บ้านเลขที่กับเลขมาตรล่าสุด (อ่านจากคอลัมน์ "เลขมาตรเดือนก่อน")
  Import_current = () => {
    const data = generateObjects(this.state.currentSheet_current)
      .filter((item) => item["บ้านเลขที่"] !== "")
      .map((item) => ({
        address_number: String(item["บ้านเลขที่"]).trim(),
        full_name: item["ชื่อ-นามสกุล"],
        current_gauge_number: Number(item["เลขมาตรเดือนก่อน"]) || 0,
      }));
    this.setState({ data_import_current: dropSampleRow(data) });
  };

  // ไฟล์ "ข้อมูลน้ำ" — ตรวจหัวคอลัมน์ แปลงเป็นบิล แล้วย้อนคำนวณเลขมาตร
  Import = () => {
    const invalidColumn = findInvalidColumn(this.state.currentSheet[WATER_BILL_SHEET_NAME][0], WATER_BILL_COLUMNS);
    if (invalidColumn) {
      alert("warning", "แจ้งเตือน", `หัวคอลัมน์ "${invalidColumn}" ไม่ถูกต้อง`);
      return;
    }

    // ทำ Map ไว้ก่อน เพื่อหาลูกค้าตามบ้านเลขที่แบบ O(1) แทนการ find ซ้ำทุกแถว
    const customerByAddress = new Map(this.state.data_customer.map((c) => [c.address_number, c]));

    let data = generateObjects(this.state.currentSheet)
      .filter((item) => item["บ้านเลขที่"] !== "")
      .map((item) => {
        const unit_used = Number(item["หน่วยที่ใช้"]);
        const address = String(item["บ้านเลขที่"] ?? "").trim();
        return buildBillRow({
          item,
          setting: this.state,
          customer: customerByAddress.get(address),
          water_bill: cal_water_bill(unit_used, this.state),
          // เลขมาตรตั้งต้นเป็น 0 ก่อน แล้วค่อยย้อนคำนวณด้านล่าง
          gauge: { current_gauge_number: 0, last_gauge_number: 0, unit_used },
        });
      });

    data = dropSampleRow(data);

    // เรียงตามบ้านเลขที่ + วันที่ แล้วใส่เลขลำดับ (id) ให้แต่ละแถว
    data = data.sort(fieldSorter(["address_number", "date_of_note"])).map((item, id) => ({ id, ...item }));

    if (this.state.data_import_current) data = this.fillGaugeNumbers(data);

    this.setState({ data_import: data });
  };

  // ย้อนคำนวณเลขมาตรของแต่ละบ้าน จากเลขมาตรปัจจุบันไล่ถอยหลังไปตามหน่วยที่ใช้ของแต่ละบิล
  fillGaugeNumbers = (data) => {
    const gaugeByAddress = new Map(this.state.data_import_current.map((a) => [a.address_number, a.current_gauge_number]));

    // จัดกลุ่มบิลตามบ้านเลขที่ (ข้อมูลเรียงมาแล้ว บิลใบล่าสุดอยู่ท้ายกลุ่ม)
    const grouped = {};
    data.forEach((item) => {
      if (!grouped[item.address_number]) grouped[item.address_number] = [];
      grouped[item.address_number].push(item);
    });

    Object.keys(grouped).forEach((address) => {
      const group = grouped[address];
      const currentGauge = gaugeByAddress.get(address);
      if (currentGauge === undefined || group.length === 0) return;

      // บิลใบล่าสุด ใช้เลขมาตรปัจจุบันเป็นเลขมาตรเดือนนี้
      const lastIndex = group.length - 1;
      group[lastIndex].current_gauge_number = currentGauge;
      group[lastIndex].last_gauge_number = currentGauge - group[lastIndex].unit_used;

      // ไล่ย้อนขึ้นไป: เลขมาตรเดือนนี้ของใบก่อน = เลขมาตรเดือนก่อนของใบถัดไป
      for (let i = lastIndex - 1; i >= 0; i--) {
        group[i].current_gauge_number = group[i + 1].last_gauge_number;
        group[i].last_gauge_number = group[i + 1].last_gauge_number - group[i].unit_used;
      }
    });

    return data;
  };

  // ---------- บันทึก ----------

  Create_Import = async () => {
    loading(true);
    const result = await POST(tokens, `v1/TH/import-file/import-water/${getStorage("project_id")}`, { import_water: this.state.data_import });
    if (result?.status) {
      // นำเข้าแล้วต้องคิดยอดค้าง/เบี้ยปรับ/ค่าต่อมิเตอร์ใหม่ทั้งโครงการ
      const cal = await calculate_water("");
      if (cal) success();
    }
    loading(false);
  };

  removeRow = (index) => {
    const data = [...this.state.data_import];
    data.splice(index, 1);
    this.setState({ data_import: data.length ? data : null });
  };

  render() {
    const { data_import, data_import_current } = this.state;

    const tdRequired = (value) => <td className={value ? "text-left" : "text-left bg-danger-light"}>{value || "-"}</td>;
    const tdMoney = (value) => <td className="text-left">{value ? toFixed(value) : "0.00"}</td>;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="นำเข้าไฟล์ข้อมูล" page3="การแจ้งหนี้และจัดเก็บค่าน้ำ (แบบไม่มีเลขมาตรเริ่มต้น - สิ้นสุด)" />
        <div className="body">
          <div className="p-3">
            {/* หัวข้อ + ปุ่ม */}
            <div className="w-100 d-flex justify-content-between mb-3">
              <h4 className="mb-3">
                <b>นำเข้าไฟล์ข้อมูล : การแจ้งหนี้และจัดเก็บค่าน้ำ (แบบไม่มีเลขมาตรเริ่มต้น - สิ้นสุด)</b>
              </h4>
              <div className="d-flex">
                <button className="btn btn-outline-primary wpx-150 mx-1" onClick={() => (window.location.href = "/import")}>
                  <span className="icon-brand mr-2">{ICON.back}</span>ย้อนกลับ
                </button>
                {data_import && (
                  <button className="btn btn-danger wpx-150 mx-1" onClick={() => this.setState({ data_import: null })}>
                    ล้างค่า
                  </button>
                )}
                {data_import && (
                  <button className="btn btn-primary wpx-150 mx-1" onClick={this.Create_Import}>
                    นำเข้า
                  </button>
                )}
              </div>
            </div>

            {/* ขั้นที่ 1 — ไฟล์เลขมาตรปัจจุบัน */}
            <div className="card border-0 p-3 mb-3">
              <h4>
                <b>เลขมาตรปัจจุบัน</b>
              </h4>
              {!data_import_current ? (
                <ExcelDropZone variant="box" templateFile={excel_file2} templateName="import_bill_water.xlsx" templateLabel="template เลขมาตรปัจจุบัน" onFile={(file) => this.handleFile(file, true)} />
              ) : (
                <h5>รายการเลขมาตรปัจจุบันที่ถูกนำเข้า {data_import_current.length} รายการ</h5>
              )}
            </div>

            {/* ตัวแปลงไฟล์เลขมาตรปัจจุบัน — ซ่อนไว้ */}
            <div className="d-none">
              <ReactExcel initialData={this.state.import_current} onSheetUpdate={(s) => this.setState({ currentSheet_current: s })} activeSheetClassName="d-none" />
            </div>

            {/* ขั้นที่ 2 — ไฟล์ข้อมูลน้ำ (เปิดให้อัปโหลดหลังนำเข้าเลขมาตรปัจจุบันแล้วเท่านั้น) */}
            {!data_import && data_import_current && (
              <div className="card border-0 p-3 mb-3">
                <h4>
                  <b>ข้อมูลน้ำ</b>
                </h4>
                <ExcelDropZone
                  variant="box"
                  templateFile={excel_file2}
                  templateName="import_bill_water.xlsx"
                  templateLabel="template การแจ้งหนี้และจัดเก็บค่าน้ำ"
                  onFile={(file) => this.handleFile(file, false)}
                />
              </div>
            )}

            {/* ขั้นที่ 3 — ตารางตรวจสอบก่อนนำเข้า */}
            {data_import && (
              <div className="card border-0 mb-3">
                <div className="card-header bg-dark-blue px-3 rounded-top">
                  <h4 className="text-white mb-0">
                    <b>ข้อมูลนำเข้า</b>
                  </h4>
                </div>
                <div className="p-3">
                  <div className="table-responsive">
                    <table className="table text-nowrap">
                      <thead>
                        <tr className="bg-dark-blue text-white">
                          <th>เลขที่</th>
                          <th>บ้านเลขที่</th>
                          <th>ชื่อ-นามสกุล</th>
                          <th>วันที่จด</th>
                          <th>เลขมาตรเดือนนี้</th>
                          <th>เลขมาตรเดือนก่อน</th>
                          <th>หน่วยที่ใช้</th>
                          <th>ค่าน้ำประปา</th>
                          <th>ค่ารักษาอุปกรณ์</th>
                          <th>ค่าใช้จ่ายส่วนกลาง</th>
                          <th>ค่าขยะ</th>
                          <th>ค่าเคเบิล</th>
                          <th>ค่าประกันอัคคีภัย</th>
                          <th>รายได้อื่น ๆ</th>
                          <th>เพิ่มหนี้</th>
                          <th>หมายเหตุเพิ่มหนี้</th>
                          <th>ลดหนี้</th>
                          <th>หมายเหตุลดหนี้</th>
                          <th>รวมเป็นเงิน</th>
                          <th>ลบ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data_import.map((item, index) => (
                          <tr key={index}>
                            <td>{item.id}</td>
                            {tdRequired(item.address_number)}
                            <td className="text-left">{item.full_name || "-"}</td>
                            <td className={item.date_of_note ? "text-left" : "text-left bg-danger-light"}>{item.date_of_note ? format_date(item.date_of_note, "dd/mm/yyyy") : "-"}</td>
                            <td className="text-left">{item.current_gauge_number || "0"}</td>
                            <td className="text-left">{item.last_gauge_number || "0"}</td>
                            <td className="text-left">{item.unit_used || "0"}</td>
                            {tdMoney(item.water_bill)}
                            {tdMoney(item.equipment_maintenance_fee)}
                            {tdMoney(item.common_expenses)}
                            {tdMoney(item.waste_cost)}
                            {tdMoney(item.cable_cost)}
                            {tdMoney(item.fire_cost)}
                            {tdMoney(item.other_income)}
                            {tdMoney(item.add_debt)}
                            <td className="text-left">{item.remark_add_debt || "-"}</td>
                            {tdMoney(item.reduce_debt)}
                            <td className="text-left">{item.remark_reduce_debt || "-"}</td>
                            {tdMoney(item.total_amount)}
                            <td>
                              <ActionIcon color="danger" icon={ICON.delete} title="ลบแถวนี้" className="mx-auto mb-0" onClick={() => this.removeRow(index)} />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {/* ตัวแปลงไฟล์ข้อมูลน้ำ — ซ่อนไว้ */}
            <div className="d-none">
              <ReactExcel initialData={this.state.import} onSheetUpdate={(s) => this.setState({ currentSheet: s })} activeSheetClassName="d-none" />
            </div>
          </div>
        </div>

        <ScrollTopButton />
      </div>
    );
  }
}
